import Vue from 'vue'

// Shared, reactive state so the mega-menu panel (rendered outside the
// mix-blend-mode: difference header, see NavMegaMenu.vue) can react to
// hover events happening inside Navigation.vue.
const state = Vue.observable({
  activeId: null,
  arrowLeft: 0,
  scrolled: false
})

let closeTimer = null

export function openDropdown(id) {
  if (closeTimer) {
    clearTimeout(closeTimer)
    closeTimer = null
  }
  state.activeId = id
}

export function scheduleCloseDropdown(delay = 150) {
  if (closeTimer) {
    clearTimeout(closeTimer)
  }
  closeTimer = setTimeout(() => {
    state.activeId = null
    closeTimer = null
  }, delay)
}

// クリック遷移はmouseleaveが発火しないため、遷移時に同期的にリセットする
export function resetDropdown() {
  if (closeTimer) {
    clearTimeout(closeTimer)
    closeTimer = null
  }
  state.activeId = null
  state.arrowLeft = 0
}

export function cancelCloseDropdown() {
  if (closeTimer) {
    clearTimeout(closeTimer)
    closeTimer = null
  }
}

export function setDropdownArrowLeft(arrowLeft) {
  state.arrowLeft = arrowLeft
}

export function setDropdownScrolled(scrolled) {
  state.scrolled = scrolled
}

export default state
